<p-dialog [(visible)]="visible" [modal]="true" [showHeader]="false" [dismissableMask]="true"
  [draggable]="false" [resizable]="false" [closeOnEscape]="true"
  [style]="{ 'box-shadow': 'none', 'border': '0', 'width': '480px', 'background': 'transparent' }"
  [breakpoints]="{ '640px': '94vw' }"
  [contentStyle]="{ 'border-radius': '1.5rem', 'padding': '0', 'background': 'transparent' }">

  @if (result(); as r) {
  <div id="broker-order-status"
    class="relative flex max-h-[88vh] flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#0d1424] text-white shadow-2xl">

    <!-- Status accent -->
    <div class="h-1 w-full shrink-0 bg-gradient-to-r" [ngClass]="status().bar"></div>

    <button type="button" id="broker-order-status-close" (click)="close()" aria-label="Close"
      class="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-full !border-0 !bg-transparent !p-0 text-gray-400 shadow-none transition hover:!bg-white/10 hover:text-white">
      <i class="pi pi-times text-sm"></i>
    </button>

    <!-- Header -->
    <div class="flex shrink-0 flex-col items-center px-8 pb-4 pt-6 text-center">
      <div class="relative mb-3 flex h-14 w-14 items-center justify-center">
        <span class="absolute inset-0 rounded-full blur-xl" [ngClass]="status().glow"></span>
        @if (r.outcome === 'placed') {
        <span class="absolute inset-0 animate-ping rounded-full bg-emerald-400/20 [animation-duration:2s]"></span>
        }
        <span class="relative flex h-14 w-14 items-center justify-center rounded-full ring-1" [ngClass]="status().ring">
          <i class="text-xl font-bold" [ngClass]="[status().icon, status().tone]"></i>
        </span>
      </div>

      <span class="mb-2 rounded-full border border-current/30 bg-white/5 px-3 py-0.5 text-[11px] font-semibold uppercase tracking-wider"
        [ngClass]="status().tone">{{ status().chip }}</span>
      <div class="text-[20px] font-semibold leading-tight tracking-tight text-gray-50">{{ status().title }}</div>
      <div class="mt-1 text-sm text-gray-400">{{ status().subtitle }}</div>
      <div class="mt-2 flex items-center gap-1.5 text-xs text-gray-500">
        <i class="pi pi-clock text-[11px]"></i>
        {{ r.at | date:'dd MMM yyyy, HH:mm:ss' }}
        <span class="text-gray-600">·</span>
        via Zerodha Kite
      </div>
    </div>

    <!-- Middle: only the order list scrolls; heading, progress and note stay put. -->
    <div class="flex min-h-0 flex-col">
    <!-- Order summary -->
    @if (legs().length) {
    <div class="flex min-h-0 flex-col px-6">
      <div class="mb-2 flex shrink-0 items-center justify-between text-[11px] font-semibold uppercase tracking-wider text-gray-500">
        <span>Order summary</span>
        <span>{{ legs().length }} {{ legs().length === 1 ? 'order' : 'orders' }}</span>
      </div>
      <div id="broker-order-status-legs" class="order-legs-scroll -mr-2 max-h-[42vh] min-h-0 space-y-2 overflow-y-auto pr-2">
        @for (leg of legs(); track $index) {
        <div class="rounded-2xl border border-white/[0.07] bg-white/[0.03] px-3.5 py-3">
          <div class="mb-2.5 flex items-center gap-2">
            <span class="rounded-md px-2 py-0.5 text-[11px] font-bold tracking-wide"
              [ngClass]="leg.side === 'BUY' ? 'bg-emerald-500/15 text-emerald-400' : 'bg-rose-500/15 text-rose-400'">
              {{ leg.side }}
            </span>
            <span class="text-[15px] font-semibold text-gray-100">
              {{ leg.symbol }}
            </span>
            <span class="rounded bg-white/[0.06] px-1.5 py-0.5 text-[10px] font-medium text-gray-400">{{ leg.exchange }}</span>
            <span class="ml-auto text-[11px] font-medium"
              [ngClass]="leg.role === 'Stop loss' ? 'text-amber-400/90' : 'text-sky-400/90'">
              {{ leg.role }}
            </span>
          </div>
          <div class="grid grid-cols-[3rem_3.75rem_minmax(0,1fr)_auto] gap-x-3">
            <div>
              <div class="text-[10px] uppercase tracking-wide text-gray-500">Qty</div>
              <div class="text-sm font-medium tabular-nums text-gray-200">{{ leg.qty }}</div>
            </div>
            <div>
              <div class="text-[10px] uppercase tracking-wide text-gray-500">Type</div>
              <div class="text-sm font-medium text-gray-200">{{ leg.type }}</div>
            </div>
            <div>
              <div class="text-[10px] uppercase tracking-wide text-gray-500">{{ leg.priceLabel }}</div>
              <div class="truncate text-sm font-medium tabular-nums text-gray-200" [title]="leg.price">{{ leg.price }}</div>
            </div>
            <div>
              <div class="text-[10px] uppercase tracking-wide text-gray-500">Product</div>
              <div class="truncate text-sm font-medium text-gray-200" [title]="leg.product">{{ leg.product }}</div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }

    <!-- Progress -->
    <div class="mx-6 mt-4 shrink-0 rounded-2xl border border-white/[0.07] bg-white/[0.02] px-4 py-3">
      @for (step of status().steps; track $index; let last = $last) {
      <div class="flex items-start gap-3">
        <div class="flex flex-col items-center">
          <span class="flex h-5 w-5 items-center justify-center rounded-full text-[10px]"
            [ngClass]="{
              'bg-emerald-500/20 text-emerald-400': step.state === 'done',
              'bg-rose-500/20 text-rose-400': step.state === 'failed',
              'bg-amber-500/20 text-amber-400': step.state === 'unknown'
            }">
            @switch (step.state) {
              @case ('done') { <i class="pi pi-check text-[9px] font-bold"></i> }
              @case ('failed') { <i class="pi pi-times text-[9px] font-bold"></i> }
              @default { <i class="pi pi-question text-[9px] font-bold"></i> }
            }
          </span>
          @if (!last) { <span class="my-0.5 h-4 w-px bg-white/10"></span> }
        </div>
        <span class="pt-0.5 text-[13px]"
          [ngClass]="step.state === 'done' ? 'text-gray-300' : step.state === 'failed' ? 'text-rose-300' : 'text-amber-300'">
          {{ step.label }}
        </span>
      </div>
      }
    </div>

    @if (r.outcome !== 'cancelled') {
    <div class="mx-6 mt-3 flex shrink-0 items-start gap-2 text-[12px] leading-relaxed text-gray-500">
      <i class="pi pi-info-circle mt-0.5 text-[12px]"></i>
      <span>Execution (complete, rejected or open) happens at the exchange and is shown in Kite → Orders.</span>
    </div>
    }

    </div>

    <!-- Actions -->
    <div class="mt-4 flex shrink-0 gap-3 border-t border-white/[0.06] bg-black/20 px-6 py-4">
      <a [href]="kiteOrdersUrl" target="_blank" rel="noopener" id="broker-order-status-kite"
        class="flex flex-1 items-center justify-center gap-2 rounded-xl border border-white/15 py-2.5 text-sm font-medium text-gray-200 no-underline transition hover:border-white/30 hover:bg-white/5">
        View in Kite
        <i class="pi pi-external-link text-[11px]"></i>
      </a>
      <button type="button" id="broker-order-status-ok" (click)="close()"
        class="flex-1 rounded-xl !border-0 bg-[linear-gradient(to_right,_#003beedc,_#2ad9d6de)] py-2.5 text-sm font-semibold text-white transition hover:opacity-90 active:opacity-80">
        Done
      </button>
    </div>
  </div>
  }
</p-dialog>
